export default (url, w, h, m = 1) => {
  if (url) {
    if (/\?/.test(url)) {
      url += '&'
    } else {
      url += '?'
    }
    url += `imageView2/${m}`
    if (w) {
      url += `/w/${w}`
    }
    if (h) {
      url += `/h/${h}`
    }
  }
  return url
}



// WEBPACK FOOTER //
// ./src/packages/utils/src/imageView.js